import { TextField } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { useUpdateCategoryMutation } from "../../../store/coefficientsApi/categoryApi";

export default function Edit({ item, onClose, id }) {
  const [updateData] = useUpdateCategoryMutation();
  const [name, setName] = React.useState(item.attributes.name);
  const [value, setValue] = React.useState(item.attributes.value);

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.alert("Вы уверены?");
    const updated = {
      name,
      value,
    };
    updateData({ updated, id });
    onClose();
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfCreation>Категория</TitleOfCreation>

      <BlockStyled width="100%" display="flex" justifyContent="flex-start">
        <TextFieldStylded
          id="outlined-basic"
          label="Наименование"
          variant="outlined"
          value={name}
          onChange={(event) => inputChangeHandler(event, setName)}
          size="small"
          width="60%"
          mrg="0 15px 0 0"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Налоговая ставка"
          variant="outlined"
          value={value}
          onChange={(event) => inputChangeHandler(event, setValue)}
          size="small"
          width="30%"
          mrg="0 15px 0 0"
        />
      </BlockStyled>

      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        ></BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfCreation = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
